import React from "react";
import "./Css/ResultView.css";
import { useNavigate } from 'react-router-dom'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import API_BASE from "../config/api";




const API_BASE_URL = `${API_BASE}`;


const StudentResult = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResult = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/student/results/${id}/full`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
            },
          }
        );
        setResult(res.data);
        console.log(res.data, 'data')
      } catch (err) {
        console.error("Failed to fetch result", err);
      } finally {
        setLoading(false);
      }
    };

    fetchResult();
  }, [id]);

  // ⛔ STOP rendering until data is ready
  if (loading) return <p>Loading...</p>;
  if (!result || !result.questions) return <p>No result found</p>;

  const questionsWithStatus = result.questions.map((q, index) => {
    let status = "skipped";

    if (q.selectedOption) {
      status = q.selectedOption === q.correctOption ? "correct" : "wrong";
    }

    return {
      ...q,
      no: index + 1,          // question number for UI
      status                 // correct | wrong | skipped
    };
  });

  // ✅ SAFE TO USE result.questions BELOW THIS LINE
  const totalQuestions = questionsWithStatus.length;

  const correctCount = questionsWithStatus.filter(q => q.status === "correct").length;
  const wrongCount = questionsWithStatus.filter(q => q.status === "wrong").length;
  const skippedCount = questionsWithStatus.filter(q => q.status === "skipped").length;

  const answered = correctCount + wrongCount;

  const columns = 3;
  const rowsPerCol = Math.ceil(totalQuestions / columns);
  const answers = result.questions.map(q => q.selectedOption);

  const optionKeyMap = {
    1: "A",
    2: "B",
    3: "C",
    4: "D",
  };

  const handleExportPDF = async () => {
    const input = document.querySelector(".review-container");

    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("Student_Result.pdf");
  };

  return (
    <div className="review-container">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन &gt;&gt; तपशील&gt;&gt; विद्यार्थी माहिती&gt;&gt; <span> निकाल</span>
        </h3>

        <div className="edit-btnn">
          <button
            className="btnprimaryyy"
            onClick={handleExportPDF}
          >
            एक्स्पोर्ट करा
          </button>

        </div>

      </div>
      <h3 className="review-title">
        {result.paperName}
      </h3>

      <div className="info-bar">
        <span>नाव : {result.studentName}</span>
        <span>इयत्ता : {result.standard}</span>
        {result.subject && <span>विषय : {result.subject}</span>}
        <span>
          एकूण गुण : {result.obtainedMarks}/{result.totalMarks}
        </span>
      </div>

      {/* Summary Cards */}
      <div className="summary-cards">
        <div className="card purple">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 34 34" fill="none">
            <path d="M16.5833 26.6667C17.1667 26.6667 17.6597 26.4653 18.0625 26.0625C18.4653 25.6597 18.6667 25.1667 18.6667 24.5833C18.6667 24 18.4653 23.5069 18.0625 23.1042C17.6597 22.7014 17.1667 22.5 16.5833 22.5C16 22.5 15.5069 22.7014 15.1042 23.1042C14.7014 23.5069 14.5 24 14.5 24.5833C14.5 25.1667 14.7014 25.6597 15.1042 26.0625C15.5069 26.4653 16 26.6667 16.5833 26.6667ZM15.0833 20.25H18.1667C18.1667 19.3333 18.2708 18.6111 18.4792 18.0833C18.6875 17.5556 19.2778 16.8333 20.25 15.9167C20.9722 15.1944 21.5417 14.5069 21.9583 13.8542C22.375 13.2014 22.5833 12.4167 22.5833 11.5C22.5833 9.94444 22.0139 8.75 20.875 7.91667C19.7361 7.08333 18.3889 6.66667 16.8333 6.66667C15.25 6.66667 13.9653 7.08333 12.9792 7.91667C11.9931 8.75 11.3056 9.75 10.9167 10.9167L13.6667 12C13.8056 11.5 14.1181 10.9583 14.6042 10.375C15.0903 9.79167 15.8333 9.5 16.8333 9.5C17.7222 9.5 18.3889 9.74306 18.8333 10.2292C19.2778 10.7153 19.5 11.25 19.5 11.8333C19.5 12.3889 19.3333 12.9097 19 13.3958C18.6667 13.8819 18.25 14.3333 17.75 14.75C16.5278 15.8333 15.7778 16.6528 15.5 17.2083C15.2222 17.7639 15.0833 18.7778 15.0833 20.25ZM16.6667 33.3333C14.3611 33.3333 12.1944 32.8958 10.1667 32.0208C8.13889 31.1458 6.375 29.9583 4.875 28.4583C3.375 26.9583 2.1875 25.1944 1.3125 23.1667C0.4375 21.1389 0 18.9722 0 16.6667C0 14.3611 0.4375 12.1944 1.3125 10.1667C2.1875 8.13889 3.375 6.375 4.875 4.875C6.375 3.375 8.13889 2.1875 10.1667 1.3125C12.1944 0.4375 14.3611 0 16.6667 0C18.9722 0 21.1389 0.4375 23.1667 1.3125C25.1944 2.1875 26.9583 3.375 28.4583 4.875C29.9583 6.375 31.1458 8.13889 32.0208 10.1667C32.8958 12.1944 33.3333 14.3611 33.3333 16.6667C33.3333 18.9722 32.8958 21.1389 32.0208 23.1667C31.1458 25.1944 29.9583 26.9583 28.4583 28.4583C26.9583 29.9583 25.1944 31.1458 23.1667 32.0208C21.1389 32.8958 18.9722 33.3333 16.6667 33.3333Z" fill="#8D62EE" />
          </svg></div>
          <div>
            <h4>एकूण प्रश्न </h4>
            <p>{totalQuestions}</p>
          </div>
        </div>

        <div className="card green">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.54 25.8721V37.9325C16.54 38.4811 16.7578 39.0069 17.1458 39.3942C17.5331 39.7822 18.059 40 18.6075 40C22.5709 40 33.9691 40 37.9325 40C38.4811 40 39.0069 39.7822 39.3949 39.3942C39.7822 39.0069 40 38.4811 40 37.9325C40 35.1179 40 28.9733 40 28.9733C40 28.5929 39.6912 28.2841 39.3108 28.2841C38.9304 28.2841 38.6217 28.5929 38.6217 28.9733C38.6217 28.9733 38.6217 35.1179 38.6217 37.9325C38.6217 38.1151 38.5493 38.2909 38.4197 38.4197C38.2909 38.5493 38.1151 38.6217 37.9325 38.6217C33.9691 38.6217 22.5709 38.6217 18.6075 38.6217C18.4249 38.6217 18.2492 38.5493 18.1203 38.4197C17.9907 38.2909 17.9184 38.1151 17.9184 37.9325V25.8721C17.9184 25.4916 17.6096 25.1829 17.2292 25.1829C16.8488 25.1829 16.54 25.4916 16.54 25.8721ZM21.3925 22.0816H2.0675C1.68708 22.0816 1.37834 21.7729 1.37834 21.3925V13.1224C1.37834 12.742 1.06959 12.4333 0.689168 12.4333C0.308747 12.4333 0 12.742 0 13.1224V21.3925C0 22.5344 0.925553 23.46 2.0675 23.46H19.2967V36.5542C19.2967 36.9346 19.6054 37.2433 19.9859 37.2433H36.5542C36.9353 37.2433 37.2433 36.9346 37.2433 36.5542V19.9859C37.2433 19.6048 36.9353 19.2967 36.5542 19.2967H24.8383C24.4579 19.2967 24.1491 19.6054 24.1491 19.9859C24.1491 20.3663 24.4579 20.675 24.8383 20.675H35.865V35.865H20.675V23.46H21.3925C22.5344 23.46 23.46 22.5344 23.46 21.3925V17.9184H37.9325C38.1151 17.9184 38.2909 17.9907 38.4197 18.1203C38.5493 18.2492 38.6217 18.4249 38.6217 18.6075V25.5275C38.6217 25.9079 38.9304 26.2166 39.3108 26.2166C39.6912 26.2166 40 25.9079 40 25.5275V18.6075C40 18.059 39.7822 17.5331 39.3949 17.1451C39.0069 16.7578 38.4811 16.54 37.9325 16.54H23.46V2.0675C23.46 0.925553 22.5344 0 21.3925 0H2.0675C0.925553 0 0 0.925553 0 2.0675C0 4.7401 0 10.3658 0 10.3658C0 10.7462 0.308747 11.0549 0.689168 11.0549C1.06959 11.0549 1.37834 10.7462 1.37834 10.3658V2.0675C1.37834 1.68639 1.68708 1.37834 2.0675 1.37834H21.3925C21.7736 1.37834 22.0816 1.68639 22.0816 2.0675V21.3925C22.0816 21.7729 21.7736 22.0816 21.3925 22.0816ZM26.4323 30.6273H30.5963L32.1042 34.0738C32.2565 34.4219 32.6631 34.5811 33.0118 34.4288C33.3599 34.2765 33.5191 33.8699 33.3668 33.5211L29.1456 23.8728C29.036 23.6219 28.7879 23.46 28.5143 23.46C28.2407 23.46 27.9926 23.6219 27.883 23.8728L23.6619 33.5211C23.5096 33.8699 23.6688 34.2765 24.0168 34.4288C24.3655 34.5811 24.7721 34.4219 24.9244 34.0738L26.4323 30.6273ZM27.0354 29.249H29.9933L28.5143 25.8686L27.0354 29.249ZM20.7033 3.44584C20.7033 3.06473 20.3952 2.75667 20.0141 2.75667H3.44584C3.06542 2.75667 2.75667 3.06473 2.75667 3.44584V20.0141C2.75667 20.3945 3.06542 20.7033 3.44584 20.7033H20.0141C20.3952 20.7033 20.7033 20.3945 20.7033 20.0141V3.44584ZM19.325 4.13501V19.325H4.13501V4.13501H19.325ZM15.2933 16.6406L16.3974 17.7447C16.6661 18.0135 17.1031 18.0135 17.3719 17.7447C17.6406 17.4759 17.6406 17.039 17.3719 16.7702L16.3526 15.7509C17.3408 14.6993 17.9466 13.2851 17.9466 11.7296C17.9466 8.48917 15.3154 5.85793 12.0749 5.85793C8.83375 5.85793 6.20251 8.48917 6.20251 11.7296C6.20251 14.9708 8.83375 17.602 12.0749 17.602C13.263 17.602 14.3692 17.2485 15.2933 16.6406ZM15.3774 14.7758C16.1169 13.9749 16.5683 12.9047 16.5683 11.7296C16.5683 9.25001 14.5545 7.23626 12.0749 7.23626C9.5946 7.23626 7.58085 9.25001 7.58085 11.7296C7.58085 14.21 9.5946 16.2237 12.0749 16.2237C12.8805 16.2237 13.6373 16.0114 14.2913 15.6393L13.6407 14.988C13.3719 14.7193 13.3719 14.2823 13.6407 14.0135C13.9095 13.7448 14.3464 13.7448 14.6152 14.0135L15.3774 14.7758Z" fill="#4BA3E0" />
          </svg></div>
          <div>
            <h4>उत्तर दिलेले प्रश्न </h4>
            <p>{answered}</p>
          </div>
        </div>
        <div className="card blue">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.54 25.8721V37.9325C16.54 38.4811 16.7578 39.0069 17.1458 39.3942C17.5331 39.7822 18.059 40 18.6075 40C22.5709 40 33.9691 40 37.9325 40C38.4811 40 39.0069 39.7822 39.3949 39.3942C39.7822 39.0069 40 38.4811 40 37.9325C40 35.1179 40 28.9733 40 28.9733C40 28.5929 39.6912 28.2841 39.3108 28.2841C38.9304 28.2841 38.6217 28.5929 38.6217 28.9733C38.6217 28.9733 38.6217 35.1179 38.6217 37.9325C38.6217 38.1151 38.5493 38.2909 38.4197 38.4197C38.2909 38.5493 38.1151 38.6217 37.9325 38.6217C33.9691 38.6217 22.5709 38.6217 18.6075 38.6217C18.4249 38.6217 18.2492 38.5493 18.1203 38.4197C17.9907 38.2909 17.9184 38.1151 17.9184 37.9325V25.8721C17.9184 25.4916 17.6096 25.1829 17.2292 25.1829C16.8488 25.1829 16.54 25.4916 16.54 25.8721ZM21.3925 22.0816H2.0675C1.68708 22.0816 1.37834 21.7729 1.37834 21.3925V13.1224C1.37834 12.742 1.06959 12.4333 0.689168 12.4333C0.308747 12.4333 0 12.742 0 13.1224V21.3925C0 22.5344 0.925553 23.46 2.0675 23.46H19.2967V36.5542C19.2967 36.9346 19.6054 37.2433 19.9859 37.2433H36.5542C36.9353 37.2433 37.2433 36.9346 37.2433 36.5542V19.9859C37.2433 19.6048 36.9353 19.2967 36.5542 19.2967H24.8383C24.4579 19.2967 24.1491 19.6054 24.1491 19.9859C24.1491 20.3663 24.4579 20.675 24.8383 20.675H35.865V35.865H20.675V23.46H21.3925C22.5344 23.46 23.46 22.5344 23.46 21.3925V17.9184H37.9325C38.1151 17.9184 38.2909 17.9907 38.4197 18.1203C38.5493 18.2492 38.6217 18.4249 38.6217 18.6075V25.5275C38.6217 25.9079 38.9304 26.2166 39.3108 26.2166C39.6912 26.2166 40 25.9079 40 25.5275V18.6075C40 18.059 39.7822 17.5331 39.3949 17.1451C39.0069 16.7578 38.4811 16.54 37.9325 16.54H23.46V2.0675C23.46 0.925553 22.5344 0 21.3925 0H2.0675C0.925553 0 0 0.925553 0 2.0675C0 4.7401 0 10.3658 0 10.3658C0 10.7462 0.308747 11.0549 0.689168 11.0549C1.06959 11.0549 1.37834 10.7462 1.37834 10.3658V2.0675C1.37834 1.68639 1.68708 1.37834 2.0675 1.37834H21.3925C21.7736 1.37834 22.0816 1.68639 22.0816 2.0675V21.3925C22.0816 21.7729 21.7736 22.0816 21.3925 22.0816ZM26.4323 30.6273H30.5963L32.1042 34.0738C32.2565 34.4219 32.6631 34.5811 33.0118 34.4288C33.3599 34.2765 33.5191 33.8699 33.3668 33.5211L29.1456 23.8728C29.036 23.6219 28.7879 23.46 28.5143 23.46C28.2407 23.46 27.9926 23.6219 27.883 23.8728L23.6619 33.5211C23.5096 33.8699 23.6688 34.2765 24.0168 34.4288C24.3655 34.5811 24.7721 34.4219 24.9244 34.0738L26.4323 30.6273ZM27.0354 29.249H29.9933L28.5143 25.8686L27.0354 29.249ZM20.7033 3.44584C20.7033 3.06473 20.3952 2.75667 20.0141 2.75667H3.44584C3.06542 2.75667 2.75667 3.06473 2.75667 3.44584V20.0141C2.75667 20.3945 3.06542 20.7033 3.44584 20.7033H20.0141C20.3952 20.7033 20.7033 20.3945 20.7033 20.0141V3.44584ZM19.325 4.13501V19.325H4.13501V4.13501H19.325ZM15.2933 16.6406L16.3974 17.7447C16.6661 18.0135 17.1031 18.0135 17.3719 17.7447C17.6406 17.4759 17.6406 17.039 17.3719 16.7702L16.3526 15.7509C17.3408 14.6993 17.9466 13.2851 17.9466 11.7296C17.9466 8.48917 15.3154 5.85793 12.0749 5.85793C8.83375 5.85793 6.20251 8.48917 6.20251 11.7296C6.20251 14.9708 8.83375 17.602 12.0749 17.602C13.263 17.602 14.3692 17.2485 15.2933 16.6406ZM15.3774 14.7758C16.1169 13.9749 16.5683 12.9047 16.5683 11.7296C16.5683 9.25001 14.5545 7.23626 12.0749 7.23626C9.5946 7.23626 7.58085 9.25001 7.58085 11.7296C7.58085 14.21 9.5946 16.2237 12.0749 16.2237C12.8805 16.2237 13.6373 16.0114 14.2913 15.6393L13.6407 14.988C13.3719 14.7193 13.3719 14.2823 13.6407 14.0135C13.9095 13.7448 14.3464 13.7448 14.6152 14.0135L15.3774 14.7758Z" fill="#4BA3E0" />
          </svg></div>
          <div>
            <h4>उत्तर न दिलेले प्रश्न </h4>
            <p>{skippedCount}</p>
          </div>
        </div>

        <div className="card red">
          <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 34 34" fill="none">
            <path d="M10.6667 25L16.6667 19L22.6667 25L25 22.6667L19 16.6667L25 10.6667L22.6667 8.33333L16.6667 14.3333L10.6667 8.33333L8.33333 10.6667L14.3333 16.6667L8.33333 22.6667L10.6667 25ZM16.6667 33.3333C14.3611 33.3333 12.1944 32.8958 10.1667 32.0208C8.13889 31.1458 6.375 29.9583 4.875 28.4583C3.375 26.9583 2.1875 25.1944 1.3125 23.1667C0.4375 21.1389 0 18.9722 0 16.6667C0 14.3611 0.4375 12.1944 1.3125 10.1667C2.1875 8.13889 3.375 6.375 4.875 4.875C6.375 3.375 8.13889 2.1875 10.1667 1.3125C12.1944 0.4375 14.3611 0 16.6667 0C18.9722 0 21.1389 0.4375 23.1667 1.3125C25.1944 2.1875 26.9583 3.375 28.4583 4.875C29.9583 6.375 31.1458 8.13889 32.0208 10.1667C32.8958 12.1944 33.3333 14.3611 33.3333 16.6667C33.3333 18.9722 32.8958 21.1389 32.0208 23.1667C31.1458 25.1944 29.9583 26.9583 28.4583 28.4583C26.9583 29.9583 25.1944 31.1458 23.1667 32.0208C21.1389 32.8958 18.9722 33.3333 16.6667 33.3333Z" fill="#E15756" />
          </svg></div>
          <div>
            <h4>चुकीचे उत्तर </h4>
            <p>{wrongCount}</p>
          </div>
        </div>


      </div>

      <div className="question-count">
        <h4>Questions Count</h4>

        <div className="question-list">
          {questionsWithStatus.map((q) => (
            <div
              key={q.questionNumber}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* Existing circle */}
              <span className={`q-circle ${q.status}`}>
                {q.no}
              </span>

              <span style={{ lineHeight: "1", marginTop: "4px" }}>
                {q.status === "correct" && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 17 13" fill="none">
                    <path d="M5.7 12.025L0 6.325L1.425 4.9L5.7 9.175L14.875 0L16.3 1.425L5.7 12.025Z" fill="#00A236" />
                  </svg>
                )}

                {q.status === "wrong" && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="#FF0000" />
                  </svg>
                )}

                {q.status === "skipped" && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.9 20 13.7667 19.8542 14.6 19.5625C15.4333 19.2708 16.2 18.85 16.9 18.3L5.7 7.1C5.15 7.8 4.72917 8.56667 4.4375 9.4C4.14583 10.2333 4 11.1 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM18.3 16.9C18.85 16.2 19.2708 15.4333 19.5625 14.6C19.8542 13.7667 20 12.9 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C11.1 4 10.2333 4.14583 9.4 4.4375C8.56667 4.72917 7.8 5.15 7.1 5.7L18.3 16.9Z" fill="#848484" />
                  </svg>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>



      {/* Review Section */}
      <div className="review-section">
        <h4>Review : Answers and Explanation For This Test</h4>

        {result.questions.map((q, index) => (
          <div className="question-box" key={index}>
            <p className="question">
              {q.questionNumber}. {q.questionText}

              {q.isCorrect && (
                <span className="correct-tag">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 17 13" fill="none">
                    <path
                      d="M5.7 12.025L0 6.325L1.425 4.9L5.7 9.175L14.875 0L16.3 1.425L5.7 12.025Z"
                      fill="#00A236"
                    />
                  </svg>{" "}
                  Correct Answer
                </span>
              )}

              {q.selectedOption && !q.isCorrect && (
                <span className="correct-tag">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="26px"
                    viewBox="0 -1290 260 990"
                    width="32px"
                    fill="#ff0000"
                  >
                    <path d="m338-288-50-50 141-142-141-141 50-50 142 141 141-141 50 50-141 141 141 142-50 50-141-141-142 141Z" />
                  </svg>{" "}
                  Wrong Answer
                </span>
              )}

              {!q.selectedOption && (
                <span className="correct-tag">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                      fill="#848484"
                    />
                  </svg>{" "}
                  Skipped Answer
                </span>
              )}
            </p>

            {q.questionImageUrl && (
              <img src={q.questionImageUrl} alt="Question" className="question-image" />
            )}

            <ul className="options">
              {q.options.map(opt => {
                const isSelected = q.selectedOption === opt.key;
                const isCorrectOption = opt.key === q.correctOption;
                const isWrongSelected = isSelected && !q.isCorrect;

                return (
                  <li
                    key={opt.key}
                    className={`${isCorrectOption ? "correct" : ""}`}
                  >
                    {opt.key}) {opt.text}

                    {opt.imageUrl && (
                      <img src={opt.imageUrl} alt="Option" className="option-image" />
                    )}

                    {/* Correct tick */}
                    {isCorrectOption && (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 17 13" fill="none">
                        <path
                          d="M5.7 12.025L0 6.325L1.425 4.9L5.7 9.175L14.875 0L16.3 1.425L5.7 12.025Z"
                          fill="#00A236"
                        />
                      </svg>
                    )}

                    {/* Wrong cross on selected option */}
                    {isWrongSelected && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="600 -1190 260 960"
                        width="26px"
                        fill="#ff0000"
                        style={{ marginLeft: "6px"}}
                      >
                        <path d="m338-288-50-50 141-142-141-141 50-50 142 141 141-141 50 50-141 141 141 142-50 50-141-141-142 141Z" />
                      </svg>
                    )}
                  </li>
                );
              })}
            </ul>

            <div className="explanation">
              <strong>Correct Answer :</strong>{" "}
              <span className="correct-answer">
                {q.correctOption}){" "}
                {q.options.find(o => o.key === q.correctOption)?.text}
              </span>

              {q.explanation && (
                <>
                  <br />
                  <strong>Explanation :</strong> {q.explanation}
                </>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="omr-container">
        <h4>Review : OMR Answer Sheet</h4>

        <div className="omr-table">
          {[...Array(columns)].map((_, colIndex) => (
            <div key={colIndex} className="omr-col">

              {/* Header */}
              <div className="omr-header">
                <span>Sr no</span>
                <span>Your Answers</span>
              </div>

              {/* Rows */}
              {[...Array(rowsPerCol)].map((_, rowIndex) => {
                const qNo = colIndex * rowsPerCol + rowIndex + 1;
                if (qNo > result.questions.length) return null;

                const question = result.questions.find(
                  q => q.questionNumber === qNo
                );

                const selectedAnswer = question?.selectedOption || null;

                return (
                  <div key={qNo} className="omr-row">
                    <span className="sr-no">
                      {qNo.toString().padStart(2, "0")}
                    </span>

                    <div className="optionss">
                      {[1, 2, 3, 4].map((o) => {
                        const optionKey = optionKeyMap[o];

                        return (
                          <span
                            key={o}
                            className={`option
          ${question.selectedOption === optionKey ? "selected" : ""}
          ${question.selectedOption === optionKey && question.isCorrect
                                ? "correct"
                                : ""
                              }
          ${question.selectedOption === optionKey && !question.isCorrect
                                ? "wrong"
                                : ""
                              }
        `}
                          >
                            {o}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div >
  );
};

export default StudentResult;
